// extracted by mini-css-extract-plugin
export default {"container":"ClansInformerButton_container_c53b9","inGame":"ClansInformerButton_inGame_a4a87"};